import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export class BackboneViewWrapper extends Component {
  static defaultProps = {
    eventsToActions: [],
    options: undefined,
    compareEventsOnUpdate: false,
  };

  componentDidMount() {
    this.mountView();
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.compareEventsOnUpdate &&
      nextProps.eventsToActions !== this.props.eventsToActions) {
      return true;
    }

    return !_.isEqual(nextProps.options, this.props.options);
  }

  componentDidUpdate() {
    this.dispose();
    this.mountView();
  }

  componentWillUnmount() {
    this.dispose();
  }

  dispose() {
    this.view.off().remove();
    this.view = null;
  }

  mountView() {
    this.view = new this.props.View(this.props.options);

    _.each(this.props.eventsToActions, ({ action, event }) => {
      this.view.on(event, action);
    });

    this.view.render().$el.appendTo(this.container);
  }

  render() {
    return (<div ref={(container) => { this.container = container; }} />);
  }
}

BackboneViewWrapper.propTypes = {
  /**
   * options which will be used to initialize backbone view
   */
  options: PropTypes.any, //eslint-disable-line
  /**
   * Backbone view which will be wrapped inside the React Component
   */
  View: PropTypes.any.isRequired, // eslint-disable-line
  /**
   * Bind callbacks to the view
   */
  eventsToActions: PropTypes.arrayOf(PropTypes.shape({
    /**
     * event name
     */
    event: PropTypes.string.isRequired,
    /**
     * The callback which will be invoked when the event is fired
     */
    action: PropTypes.func.isRequired,
  })),
  /**
   * Controls whether eventsToActions will be compared on shouldComponentUpdate or not
   */
  compareEventsOnUpdate: PropTypes.bool,
};
